import useTestId from '@ori/testid-generator';
import type { FC, ReactElement } from 'react';

import { useSearchInput } from '../../context/navigation';
import type { VipAccessResponse } from '../../models';
import { AccountFlyout } from '../Account/AccountFlyout';
import { BurgerMenu } from '../BurgerMenu';
import { JoinMenu } from '../Join/JoinMenu';
import { LeftActionsSection } from '../LeftActionsSection';
import { RightActionsSection } from '../RightActionsSection';
import { SearchInput } from '../SearchInput';
import { SearchResults } from '../SearchResults/SearchResults';
import { TopAreaBanner } from '../TopAreaBanner';
import { Root } from './styles';

export interface TopAreaProps {
  isTopBannerVisible?: boolean | undefined;
  personalMenu?: ReactElement | undefined;
  vipAccess?: VipAccessResponse | undefined;
}

export const TopArea: FC<TopAreaProps> = ({ isTopBannerVisible, personalMenu }) => {
  const { getTestId } = useTestId();
  const { isVisible: isSearchInputVisible } = useSearchInput();

  return (
    <Root
      isSearchInputVisible={isSearchInputVisible}
      isTopBannerVisible={isTopBannerVisible}
      data-testid={getTestId('root')}
    >
      <LeftActionsSection />
      <RightActionsSection />
      <BurgerMenu />
      <AccountFlyout />
      <SearchResults />
      <JoinMenu />
      {personalMenu}
      <TopAreaBanner />
      <SearchInput showOnlyOn="mobile" />
    </Root>
  );
};
